import { render, staticRenderFns } from "./splitpane.vue?vue&type=template&id=1211b878&scoped=true"
import script from "./splitpane.vue?vue&type=script&lang=js"
export * from "./splitpane.vue?vue&type=script&lang=js"
import style0 from "./splitpane.vue?vue&type=style&index=0&id=1211b878&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211b878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1211b878')) {
      api.createRecord('1211b878', component.options)
    } else {
      api.reload('1211b878', component.options)
    }
    module.hot.accept("./splitpane.vue?vue&type=template&id=1211b878&scoped=true", function () {
      api.rerender('1211b878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/splitpane.vue"
export default component.exports